module.exports = __webpack_public_path__ + "static/media/amusnet.86d97d33.svg";